import {api} from '../../../shared';
import {
  CategoriesFilter,
  CategoryModel,
  CategoryWithMetaModel,
  CreateCategoryDTO,
  EditCategoryDTO,
  EditCategoryParams,
} from '../model';

export const categoriesApi = {
  getCategories: async (params: CategoriesFilter = {}): Promise<CategoryWithMetaModel> => {
    const {data} = await api.get<CategoryWithMetaModel>('/api/fundraising/admin/categories', {params});
    return data;
  },

  createCategory: async (category: CreateCategoryDTO): Promise<CategoryModel> => {
    const {categoryGroupId, imageUploadId, ...rest} = category;
    const body = {
      ...rest,
      groupId: categoryGroupId ?? null,
      imageUploadId: imageUploadId ?? null,
    };
    const {data} = await api.post<CategoryModel>('/api/fundraising/admin/categories', body);
    return data;
  },

  getCategoryById: async (categoryId: string): Promise<CategoryModel> => {
    const {data} = await api.get<CategoryModel>(`/api/fundraising/admin/categories/${categoryId}`);
    return data;
  },

  updateCategory: async ({
    categoryId,
    name,
    order,
    categoryGroupId,
    imageFileName,
    imageUploadId,
  }: EditCategoryParams): Promise<CategoryModel> => {
    const body: EditCategoryDTO = {
      name,
      order,
      categoryGroupId,
      imageFileName: imageFileName ?? null,
      imageUploadId: imageUploadId ?? null,
    };
    const {data} = await api.post<CategoryModel>(`/api/fundraising/admin/categories/${categoryId}`, body);
    return data;
  },

  deleteCategory: async (categoryId: string): Promise<void> => {
    await api.delete(`/api/fundraising/admin/categories/${categoryId}`);
  },

  moveCategoryToGroup: async ({categoryId, newGroupId}: {categoryId: string; newGroupId: string}): Promise<void> => {
    await api.post(`/api/fundraising/admin/categories/${categoryId}/group`, {newGroupId});
  },
};
